export const wrapperStyles = {
  display: "flex",
  bg: "grayScale.1",
  px: [0, 0, 0],
  justifyContent: "center"
};
